import { setNotificationAdapter } from "@spark/services/http";
import { notification } from '@spark/ui-components/utils/notification';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './containers/App/App';
import * as serviceWorker from './serviceWorker';
import './i18n';
setNotificationAdapter(notification);

const root = createRoot(document.getElementById('root'));

root.render(<React.StrictMode>
    <App />
  </React.StrictMode>); // If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();
